import React from "react";
import axios from "axios";
import MemberPayOrNotList from "./MemberPayOrNotList";
import CustomerDetail from "./CustomerDetail";

class Viewcustomermodal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customerIdCrypt: this.props.customerIdCrypt,
            customer_data: null,
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
        };
    }

    setLoaderFunction = () => {

        this.setState({
            loader_status: true,
            try_again_status: false,
            main_content_status: false,
        });
    };
    closeLoaderFuncion = () => {
        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: true,
        });
    };

    enableTryAgain = () => {

        this.setState({
            loader_status: false,
            try_again_status: true,
            main_content_status: false,
        });
    };


    componentDidMount() {
        this.getDataForView();
    }


    async getDataForView() {
        try {
            this.setLoaderFunction()
            const token = localStorage.getItem("token");
            const id = this.props.leadId;
            const [
                { data: edit },

            ] = await Promise.all([
                axios.get("api/customer/edit/" + this.state.customerIdCrypt, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),

            ]);
            this.setState({ customer_data: edit });
            this.closeLoaderFuncion()

        } catch (error) {
            console.error("Error fetching data: ", error);
            this.enableTryAgain()
        }
    }




    tryAgain = () => {

        this.getDataForView()

    }



    render() {

        return (
            <>
                <div>
                    {/* Advanced Loader Design */}
                    {this.state.loader_status && (
                        <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                            <div className="bg-white p-4 rounded-md">
                                <div className="flex items-center justify-center">
                                    <div
                                        className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                                </div>
                                <p className="text-center mt-4">Loading...</p>
                            </div>
                        </div>
                    )}
                    {/*loader_status------------------------------------------------------------------------*/}

                    {/* Advanced Try Again Design */}
                    {this.state.try_again_status && (
                        <div className="h-screen top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-white-800 bg-opacity-50 z-50">
                            <div className="animate-fadeInUp bg-white p-8 border border-grey-200 rounded-lg shadow-lg text-center">
                                <p className="text-red-500 mb-4 font-semibold">{this.state.error_customize}</p>
                                <button
                                    type="button"
                                    onClick={this.tryAgain}
                                    className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-500 focus:outline-none focus:ring focus:border-indigo-300 transition-transform transform hover:scale-105"
                                >
                                    Try Again
                                </button>
                            </div>
                        </div>
                    )}


                    {this.state.main_content_status && (
                        <div>
                            <CustomerDetail customer={this.state.customer_data} />
                            <MemberPayOrNotList
                                setLoaderFunction={this.props.setLoaderFunction}
                                closeLoaderFuncion={this.props.closeLoaderFuncion}
                                customerIdCrypt={this.state.customerIdCrypt}
                            />
                        </div>
                    )}

                </div>

            </>
        );
    }
}

export default Viewcustomermodal
